<template>
  <div class="toolbar">
    <div class="search">
      <div class="d-flex">
        <RexSearchSelect
          :current="getCurrentAlarmCapability"
          :data="getAlarmCapabilities"
          width="18.75rem"
          @onChoose="(item) => selectCapabilityOption(item)"
          :searchPlaceholder="searchCapability"
          :heading="selectCapability"
          :objectValueIndex="1"
          class="capability-dropdown"
          id="search-select-capablity"
        />
        <RexSearchSelect
          :current="getCurrentApplication"
          :data="getAlarmApplicationsList"
          width="18.75rem"
          @onChoose="(item) => selectApplicationOption(item)"
          :searchPlaceholder="searchApplication"
          :heading="selectApplication"
          :objectValueIndex="1"
          id="search-select-application"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';
import { parseServiceObjFromApplication } from '@/utils/helper-function';
import { CAPABILITY_WSM } from '@/utils/constants';

export default {
  components: { RexSearchSelect },
  data() {
    return {
      searchCapability: this.$t('searchCapability'),
      selectCapability: this.$t('selectCapability'),
      searchApplication: this.$t('searchApplication'),
      selectApplication: this.$t('selectApplication'),
      subTypeNameMapping: {
        ES: 'Elasticsearch',
        CB: 'Couchbase',
        MY: 'MySQL',
        MS: 'MsSQL',
        OR: 'Oracle',
        PG: 'PostgreSQL',
      },
    };
  },

  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapGetters('alarmState', [
      'getCurrentAlarmCapability',
      'getAlarmCapabilities',
      'getAlarmApplications',
      'getCurrentApplication',
    ]),
    getAlarmApplicationsList() {
      let applications = this.getAlarmApplications;

      if (Array.isArray(applications) && applications.length > 0) {
        applications.forEach((application) => {
          let service = parseServiceObjFromApplication(application);
          if (service && service.type === 'D') {
            application.label = this.subTypeNameMapping[service.sub]
              ? this.subTypeNameMapping[service.sub] + ' > ' + application.label
              : application.label;
          }
        });
      }

      return applications;
    },
  },
  methods: {
    ...mapMutations('alarmState', [
      'SET_ALARM_CAPABILITY',
      'SET_CURRENT_APPLICATION',
    ]),
    ...mapActions('alarmState', ['GET_ALARM_APPLICATIONS']),
    ...mapActions('wsmState/detail', ['getWSMInstances']),
    selectCapabilityOption(item) {
      this.SET_ALARM_CAPABILITY(item);
    },
    fetchWSMInstances(serviceId) {
      this.getWSMInstances({
        serviceId: serviceId,
        properties: [],
      });
    },
    selectApplicationOption(item) {
      this.SET_CURRENT_APPLICATION(item);
    },
  },
  created() {
    this.GET_ALARM_APPLICATIONS(this.getDurationTime);
  },

  watch: {
    getCurrentAlarmCapability() {
      this.GET_ALARM_APPLICATIONS(this.getDurationTime);
    },
    getCurrentApplication() {
      if (
        this.getCurrentAlarmCapability &&
        this.getCurrentAlarmCapability.key === CAPABILITY_WSM &&
        this.getCurrentApplication &&
        this.getCurrentApplication.key
      ) {
        this.fetchWSMInstances(this.getCurrentApplication.key);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar {
  margin-left: 0em;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  margin-left: 0em;
  margin-top: 0.8125em;
  background-color: transparent;
  color: $font-primary;
  width: 100%;
}

.item {
  margin-right: 1.875em;
}
.dropdown-ph > .select-box {
  width: 60rem !important;
}
.capability-dropdown {
  margin-right: 10px;
}
</style>
